import { DemonstrativoExtratoBancarioTab } from "../demonstrativo-extrato-bancario.types";

export function formatarMoedaBR(valor: number) {
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(valor);
}
